import { render, staticRenderFns } from "./VolumeSelector.vue?vue&type=template&id=62ffb0f3&"
import script from "./VolumeSelector.vue?vue&type=script&lang=js&"
export * from "./VolumeSelector.vue?vue&type=script&lang=js&"
import style0 from "./VolumeSelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports